<template>
    <v-dialog :value="show" max-width="500" persistent>
        <v-card>
            <v-card-title class="headline">
                Atualizar demais tarifas?
            </v-card-title>

            <v-card-text>
                <p>
                    Ótimo! A tarifa desta reserva foi atualizada com sucesso.
                    Deseja aproveitar para revisar também as <strong>demais tarifas do seu hotel</strong>
                    e evitar novas recusas por preço?
                </p>
            </v-card-text>

            <v-card-actions class="pb-4">
                <v-btn text :disabled="loading" @click="$emit('dismiss')">
                    Não, obrigado
                </v-btn>
                <v-spacer />
                <v-btn
                    color="primary"
                    :loading="loading"
                    @click="$emit('confirm')"
                >
                    Sim, quero atualizar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PromptUpdateOtherFaresModal',

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
